module.exports = "pegasus_template/assets/tech/medium/1.jpg";